/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindEmployeeQueryResponse } from './FindEmployeeQueryResponse';
import {
    FindEmployeeQueryResponseFromJSON,
    FindEmployeeQueryResponseFromJSONTyped,
    FindEmployeeQueryResponseToJSON,
} from './FindEmployeeQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface FindTeamMembersQueryResponse
 */
export interface FindTeamMembersQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof FindTeamMembersQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindEmployeeQueryResponse>}
     * @memberof FindTeamMembersQueryResponse
     */
    data: Array<FindEmployeeQueryResponse>;
}

/**
 * Check if a given object implements the FindTeamMembersQueryResponse interface.
 */
export function instanceOfFindTeamMembersQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function FindTeamMembersQueryResponseFromJSON(json: any): FindTeamMembersQueryResponse {
    return FindTeamMembersQueryResponseFromJSONTyped(json, false);
}

export function FindTeamMembersQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindTeamMembersQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindEmployeeQueryResponseFromJSON)),
    };
}

export function FindTeamMembersQueryResponseToJSON(value?: FindTeamMembersQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindEmployeeQueryResponseToJSON)),
    };
}

